export default __webpack_public_path__ + "static/media/csharp-dotnet-1.89b8de86.png";